module.exports = __webpack_public_path__ + "pcid/img/tishi.0000c6e9.png";